/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const ActionListHeaderKeys = {
  EXAMPLES: 'examples',
  INVALID_REFERENCES: 'invalid_references',
  OVERFLOW: 'overflow',
  SYSTEM_ACTIONS: 'system_actions',
  TITLE: 'title',
  UPDATED: 'updated'
};

export enum CollectionHeaderKeys {
  COLLECTION = 'collection',
  TITLE = 'title',
  NAME = 'display_name',
  UPDATED = 'updated',
  COUNTS = 'counts',
  EXAMPLES = 'examples',
  OVERFLOW = 'overflow',
  STATUS = 'status'
}

export enum CollectionListIds {
  COLLECTION = 'collection',
  ACTION = 'action',
  CONVERSATIONAL_SKILL_ACTION = 'cs-action',
  AI_GUIDED_ACTION = 'ai-'
}
// directly related to CONVERSATIONAL_SKILL_ACTION above
export const ConvoSkillActionPrefix = {
  PREFIX: 'cs-',
  PREFIX_LENGTH: 3
};

export const AIGuidedActionPrefix = {
  PREFIX: 'ai-',
  PREFIX_LENGTH: 3
};

export const VariableListHeaderKeys = {
  ACTIONS_COUNT: 'action_references',
  DATA_TYPE: 'data_type',
  DESCRIPTION: 'description',
  DELETE: 'delete',
  INITIAL_VALUE: 'initial_value',
  TITLE: 'title',
  VARIABLE: 'variable'
};

export const ColumnDirections = {
  ASC: 'ASC',
  DESC: 'DESC',
  NONE: 'NONE'
};

export const enum FiltersType {
  TRIGGERS = 'triggers',
  EXTENSION = 'extension',
  VARIABLE = 'variable',
  ACTIONS = 'actions',
  ACTIONS_WITH_ERROR = 'actionsWithError',
  DISPLAY_NAMES = 'displayNames'
}

export const enum ActionType {
  AI_GUIDED = 'ai_guided',
  CUSTOM = 'custom',
  CONVERSATIONAL_SKILL = 'conversational_skill'
}

export const AIGuidedActionStep = [
  {
    step: 'step_999',
    resolver: {
      type: 'continue'
    },
    variable: 'step_999',
    id: 'step_999'
  }
];
